import * as React from 'react';
import { Field } from 'redux-form';

import { FormDateTime } from '@inqool/uas-web-core/es/components/controls/DateTime';

import * as T from '@components/form/Date/_dateTypes';
import { endOfDay } from 'date-fns';
import { now } from 'moment';

const Date: React.SFC<T.OutterProps & T.InnerProps> = props => {
  return (
    <FormDateTime
      fullWidth={true}
      placeholder=""
      floatingLabelText={props.label}
      dateOnly={true}
      wrapperStyle={{ width: '100%' }}
      maxDate={props.allowFuture ? undefined : endOfDay(now())}
      onInputChange={props.onInputChange}
      {...props}
    />
  );
};

export default Date;

export class DateField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Date/Date.tsx